<template>
  <section class="reports">
    <za-banner></za-banner>
    <article class="article">
      <section class="article-inner">
        <div class="inner-mid">
          <img class="article-item-img" :src="part1" alt="">
          <div class="item-right">
            <h2 class="article-item-title">- 上海趋致信息技术 -</h2>
            <div>
              <p class="article-item-desc">我们是一支经验丰富的互联网创新开发团队，我们时刻洞察客户需求，凭着多年的实践经验和高效前沿创新的技术，打造面向不同行业所需的移动互联网专业解决方案。</p>
              <p class="article-item-desc">我们坚持高标准的服务，通过技术来丰富互联网用户的生活，助力个人的移动互联网体验升级。</p>
              <p class="article-item-desc">我们的使命是“用户为本，科技向善”。</p>
            </div>
            <div>
              <h2 class="article-item-title">- 合作联系邮箱 -</h2>
              <p>support@quuzhi.com</p>
              <h2 class="article-item-title">- 公司地址 -</h2>
              <p>上海市奉贤区金海公路6055号11幢5层</p>
            </div>
          </div>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      part1: require('../assets/reports.png')
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.article {
  width: 1200px;
  margin: 50px auto 0 auto;
  padding-bottom: 300px;
}
.article-title {
  font-size: 36px;
  text-align: center;
}
.article-inner {

}
.article-inner p{
  margin-bottom: 10px;
  text-align: center;
}
.article-left {
  float: left;
}
.article-item {
  width: 680px;
  overflow: hidden;
  margin: 0 86px 44px 0;
}
.inner-mid {
  display: flex;
  width: 100%;
  justify-content: center;
}
.article-item:nth-child(4n) {
  margin-right: 0;
}
.article-item-title {
  color: #000;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 32px;
  margin-bottom: 16px;
}
.article-item-title + p{
  margin-bottom: 20px;
}
.article-item-desc {
  color: #333;
  text-align: left !important;
  margin-bottom: 20px !important;
}
.article-right > h4 {
  color: #000;
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 16px;
}
.article-right li {
  color: #016091;
  line-height: 30px;
}
.article-right li:hover {
  text-decoration: underline;
}
.article-item-img {
}
.item-right h2,p{
  text-align: center;
  width: 400px;
  margin-bottom: 50px;
}
.item-right {
  margin: auto 0 auto 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>